// Feature Flags für die Hustle-Plattform
// Einfacher Wechsel zwischen verschiedenen Modi

export const FEATURE_FLAGS = {
  // Feature Flags für die Hustle-Plattform
  // (ALPHA_TESTER_GATE_ENABLED entfernt - Account-Request-System nicht mehr verwendet)
  I18N_ENABLED: true, // i18n Feature-Flag (default: deaktiviert)
  /** Wenn true: Nur Tracks mit Beatmap im neuen Format (time + isDownbeat) anzeigen. Zum Testen der Sync-Funktion. */
  BACKGROUND_MUSIC_ONLY_WITH_STRUCTURED_BEATMAP: true,
  /**
   * Privatstunden (Mentor/Mentee-Workspace, FABs, Vorbereitung).
   * Bei false: UI ausgeblendet; Kontexte setzen den Modus zurück (kein „hängender“ Zustand).
   */
  PRIVATE_CLASS_UI_ENABLED: false,
} as const;

// Hilfsfunktion um Feature Flags zu prüfen
export const isFeatureEnabled = (flag: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[flag];
};

// Debug-Funktion um alle Flags anzuzeigen
export const getFeatureFlags = () => {
  console.log("🔧 Feature Flags:", FEATURE_FLAGS);
  return FEATURE_FLAGS;
};
